import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let id = useDataValue({
    context: 'message',
    path: 'params.patient_id',
    viewPath: props.viewPath,
  })

  return {
    requestPolicy: 'network-only',
    variables: {
      id,
    },
  }
}
